"use client";

import { cn } from "utils";
import { formatAskUserQuestionAnswerDisplay } from "./parseAskUserQuestionResult";
import {
  InteractiveToolResultCard,
  InteractiveToolResultCards,
} from "./InteractiveToolResultCard";
import type { AskUserQuestionAnswer, AskUserQuestionToolInfo } from "./types";

export interface AskUserQuestionResultCardProps {
  /** 单题已提交答案（来自 result 数组的一项） */
  answer: AskUserQuestionAnswer;
  /** 与交互态一致，用于 data-tool-name / data-tool-call-id 埋点与调试 */
  toolInfo?: AskUserQuestionToolInfo;
  className?: string;
}

/**
 * ask_user_question 查看态单卡（只读）。
 * 内部复用 InteractiveToolResultCard。
 */
export const AskUserQuestionResultCard: React.FC<
  AskUserQuestionResultCardProps
> = ({ answer, toolInfo, className }) => {
  const answerText = formatAskUserQuestionAnswerDisplay(answer);

  return (
    <InteractiveToolResultCard
      title={answer.question}
      body={answerText}
      toolInfo={toolInfo}
      className={className}
      testId="ask-user-question-result-card"
    />
  );
};

export interface AskUserQuestionResultCardsProps {
  /** parseAskUserQuestionResult 的完整输出；length > 1 时纵向多张卡 */
  answers: AskUserQuestionAnswer[];
  toolInfo?: AskUserQuestionToolInfo;
  className?: string;
}

/**
 * 多题查看态容器：对 result 数组 map 渲染多张 AskUserQuestionResultCard。
 */
export const AskUserQuestionResultCards: React.FC<
  AskUserQuestionResultCardsProps
> = ({ answers, toolInfo, className }) => {
  const items = answers
    .map((answer) => ({
      key: `${answer.questionIndex}-${answer.question}`,
      title: answer.question,
      body: formatAskUserQuestionAnswerDisplay(answer),
    }))
    .filter((item) => item.body.trim().length > 0);

  return (
    <InteractiveToolResultCards
      items={items}
      toolInfo={toolInfo}
      className={cn(className)}
    />
  );
};
